window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

// try {
//     require('bootstrap');
// } catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// const token = document.querySelector('meta[name="csrf-token"]');
// if (token) {
//   window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.getAttribute('content');
// }

window.axios.defaults.timeout = 10000;

window.axios.interceptors.response.use(
    response => {
      return response;
    },
    error => {
        let errorResponse = error.response;
        // console.log(errorResponse);
        if (errorResponse && errorResponse.status === 401) {
            //    && errorResponse.config && !errorResponse.config.__isRetryRequest
            window.location.href = '/login';
        }

        return Promise.reject(error);
    }
  );



/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');
window.Pusher.logToConsole = process.env.MIX_PUSHER_APP_DEBUG;

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: process.env.MIX_PUSHER_APP_FORCE_TLS,
    encrypted: process.env.MIX_PUSHER_APP_ENCRYPTED,
    auth: {
        headers: {
            'X-CSRF-TOKEN': document.querySelector("meta[name='csrf-token']").getAttribute('content')
        }
    }
});
